import {
  ACTION_PUT_REWARD_PROGRAM,
  ACTION_PUT_REWARD_PROGRAM_SUCCESS,
  ACTION_PUT_REWARD_PROGRAM_FAILURE,
  API_CALL,
} from '../../../configs/ActionTypes';
import { Dispatch } from 'redux';
import { enqueueSnackbarHandler } from '../../Status';

export type RewardProgramValue = 'none' | 'points' | 'rebate';

export type RewardProgramPayload = {
  value: RewardProgramValue;
  organizationId?: string;
};

export function putRewardProgramSetting(
  organizationSettingId: string,
  data: RewardProgramPayload,
  onSuccess?: () => void,
  onFailure?: () => void,
) {
  return (dispatch: Dispatch) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `OrganizationSettings/${organizationSettingId}`,
        method: 'put',
        data: JSON.stringify(data),
        success: (response: any) => {
          if (response?.type === 'error') {
            dispatch(requestFailed(response));
            enqueueSnackbarHandler(dispatch, { updateFeatureError: true }, 'error');
            onFailure?.();
            return;
          }

          enqueueSnackbarHandler(dispatch, { updateFeatureSuccess: true }, 'success');
          dispatch(requestSuccess(response));
          onSuccess?.();
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
          enqueueSnackbarHandler(dispatch, { updateFeatureError: true }, 'error');
          onFailure?.();
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_PUT_REWARD_PROGRAM,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_PUT_REWARD_PROGRAM_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_PUT_REWARD_PROGRAM_FAILURE,
    payload: responseJSON,
  };
}
